import styled from 'styled-components';
import InlineSVG from 'svg-inline-react';
import { BLACK } from 'root/theme';
import media from '../../oldpantheon/utils/media';
import { StyledButton } from '../../styled_constants';

export const SignSeasonContent = styled.div`
  display: flex;
  ${media.extraSmall`
    display:block;
  `}
`;

export const CurrentSignIcon = styled(InlineSVG)`
  width: 9.375rem;
  display: block;
  ${media.extraSmall`
    width: 6rem;
  `}
  svg {
    width: 85%;
  }
`;

export const CurrentSignHeader = styled.h2`
  font-size: 1.5rem;
  margin: 0 auto;
  text-align: center;
  font-family: "PT Serif";
  display: block;
  color: ${BLACK};
  ${media.extraSmall`
    text-align: center;
    margin: 0rem;
  `}
`;

export const CurrentSign = styled.span`
  font-family: Calistoga;
`;

export const CurrentSignDate = styled.div`
  text-align: center;
  ${media.extraSmall`
    display: none;
  `}
`;

export const CurrentHoroscope = styled.div`
  margin-right: 1.5rem;
  margin-bottom: 1.5rem;
  ${media.extraSmall`
    display: none;
  `}
`;

export const ReadMoreButton = styled(StyledButton)`
  margin-left: 0;
`;

export const MobileButton = styled.div`
  display: block;
  a {
    text-decoration: none;
  }
  ${media.extraSmall`
    display: block;
  `}
`;

export const MobileCurrentSignDate = styled.div`
  display: block;
  text-align: center;
  font-size: 1.25rem;
  color: ${BLACK};
  margin-bottom: 1rem;
  font-family: 'PT Serif';
  font-size: 0.875 rem;
`;

export const MobileColumns = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;
